module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-switch"
  }, [_c('div', [_c('mt-switcher', {
    attrs: {
      "label": "标题",
      "wrapperpaddingleft": "10px"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v("\n    " + _vm._s(_vm.value1) + "\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6338fa18","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/switcher.vue
// module id = 625
// module chunks = 0